<app-modal
  [isOpen]="isOpen"
  modalTitle="Patient Details"
  [maxWidth]="'max-w-[100vw]'"
  [minHeight]="'min-h-[calc(100dvh-1rem)]'"
  [zIndex]="100030"
  (close)="onClose()">
  <div class="patient-detail-overlay-host-inner -m-6 max-h-[calc(100dvh-5rem)] overflow-y-auto overflow-x-hidden bg-[#f8fafc]">
    <app-patient-detail
      *ngIf="accountNo != null"
      [embedAsOverlay]="true"
      [overlayAccountNo]="accountNo"
      [overlayInitialTab]="initialTab"
      [overlayWorkflowPatientVisitId]="workflowPatientVisitId"
      [overlayWorkflowAppointmentStatus]="workflowAppointmentStatus">
    </app-patient-detail>
  </div>
</app-modal>
